import {useAppSelector} from "../../../../../../redux/hooks";
import {
  getMySongsPageFilterGenresMenuTitle
} from "../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface ISongsMobileFilterGroupGenresLogic {
  filterLabel: string;
}

export const useSongsMobileFilterGroupGenresLogic = (): ISongsMobileFilterGroupGenresLogic => {
  const filterLabel = useAppSelector(getMySongsPageFilterGenresMenuTitle);
  return {
    filterLabel,
  };
}
